/**
 * Иконки разделов нижней панели.
 *
 * Назначение файла: линейная графика без внешних файлов, чтобы панель работала
 * в офлайне и не тянула шрифт иконок. Обводка берёт цвет от родителя
 * (currentColor), поэтому подсветка раздела делается одним свойством color.
 */

export type NavIconName = "map" | "hero" | "hearth" | "wallet" | "debt";

const PATHS: Record<NavIconName, readonly string[]> = {
  // Сота улья: сетка гексов — главный экран игры
  map: ["M12 3.2 19 7.1v7.8L12 18.8 5 14.9V7.1z", "M12 3.2v15.6", "M5 7.1l14 7.8", "M19 7.1 5 14.9"],
  // Герой: сам игрок, без класса и без выбора
  hero: ["M12 4.5a3.4 3.4 0 1 1 0 6.8 3.4 3.4 0 0 1 0-6.8z", "M4.8 19.5c1-3.4 3.8-5.2 7.2-5.2s6.2 1.8 7.2 5.2"],
  // Очаг: дом с огнём внутри
  hearth: ["M4 11 12 4.5 20 11v8.5H4z", "M9.6 19.5c0-2.2 2.4-2.8 2.4-5 1.6 1.2 2.4 2.6 2.4 5"],
  // Кошелёк с кристаллом
  wallet: ["M4 8.2h16v10.6H4z", "M4 8.2 12 4.6l8 3.6", "M15.6 13.5h1.8"],
  // Долг: чаша весов с перекосом
  debt: ["M12 4.6v14.8", "M6.4 19.4h11.2", "M4.4 9.4h15.2", "M4.4 9.4 7 14.2h-5z", "M19.6 9.4 17 14.2h5z"],
};

export interface NavIconProps {
  readonly name: NavIconName;
}

export function NavIcon({ name }: NavIconProps): React.JSX.Element {
  return (
    <svg
      className="liquid-nav__icon"
      viewBox="0 0 24 24"
      width="22"
      height="22"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name].map((d) => (
        <path
          key={d}
          d={d}
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
}
